// this file is auto generated by ng g @mooxy/schematics:data-access
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {ContractPartnersPartialState} from './contractPartners.reducer';
import * as ContractPartnersActions from './contractPartners.actions';
import {ActionWithCorrelationAttributes} from '@mooxy/correlation';
import {ContractPartnersQuery} from "./contractPartners.selectors";

@Injectable()
// @Injectable({
//   providedIn: 'root'
// })
export class ContractPartnersFacade {

  all$ = this.store.pipe(select(ContractPartnersQuery.getAllContractPartners));

  constructor(private store: Store<ContractPartnersPartialState>) {
  }

  loadAll(correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(ContractPartnersActions.loadAll(), correlationId)
  }

  setContractPartner(networkPartnerId: string, cartId: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(ContractPartnersActions.setContractPartner({networkPartnerId, cartId}), correlationId)
  }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

}
